// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2iqLT","avatar":"style_avatar__2wiwf"};